/* eslint-disable no-unused-vars */
import { axios } from '../index'
import get_menu_basic_info from '@/jsons-data/mocks/get_menu_basic_info.json'
import get_dp_menu from '@/jsons-data/mocks/DPMenus/menus.json'
import get_menu_stay from '@/jsons-data/mocks/get_menu_stay.json'
import get_vacancy_calendar from '@/jsons-data/mocks/get_vacancy_calendar.json'

const resource = '/v1/stay'

export default {
  async getDPMenuBasicInfo(menuNo) {
    // return axios.get(`${resource}/menu/${menuNo}`)
    return new Promise((resolve, reject) => {
      resolve({
        status: 200,
        data: get_dp_menu
      })
    })
  },
  async getMenuBasicInfo(menuNo) {
    // return axios.get(`${resource}/menu/${menuNo}`)
    return new Promise((resolve, reject) => {
      resolve({
        status: 200,
        data: get_menu_basic_info
      })
    })
  },
  async getMenuStay(menuNo, params = {}) {
    // return axios.get(`${resource}/menu/${menuNo}/stay`, { params })
    return new Promise(resolve => {
      resolve({
        status: 200,
        data: get_menu_stay
      })
    })
  },
  async getFacilities(params = {}) {
    // facilities/{latitude}/{longitude}?count=xyz&startIndex=xyz
    const queryParams = {
      count: params.pageSize ? params.pageSize : 10,
      startIndex: params.page ? +params.page - 1 : 0
    }
    return axios.get(
      `${resource}/menu/facilities/${params.latitude}/${params.longitude}`,
      { params: queryParams }
    )
  },
  async getSameCategoryMenus(queryParams = {}) {
    return axios.get(`${resource}/menu`, {
      params: {
        catLrgClassCd: queryParams.catLrgClassCd ? queryParams.catLrgClassCd : '',
        catMidClassCd: queryParams.catMidClassCd ? queryParams.catMidClassCd : '',
        catSmlClassCd: queryParams.catSmlClassCd ? queryParams.catSmlClassCd : '',
        count: queryParams.pageSize ? queryParams.pageSize : 10,
        startIndex: queryParams.page ? queryParams.page - 1 : 0
      }
    })
  },
  async getPhotoGallery(menuNo) {
    return axios.get(`${resource}/menu/${menuNo}/images`)
  },
  getFavourite(params) {
    return new Promise((resolve) => {
      // axios.get(`${resource}/menu/favourite`, { params }).then(
      //   (response) => {
      //     resolve(response.data)
      //   },
      //   () => {
      //     resolve({})
      //   }
      resolve(
        { "id": null, "menuNo": "10160875", "favourite": false, "quantity": 0 }
      )
    })
  },

  getVacancyCalendar(body) {
    return new Promise((resolve) => {
      resolve(get_vacancy_calendar)
    })
  }
}
